import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EPlaceholderDisabledActionType {
  DisablePlaceholder = 'placeholderDisabled/disablePlaceholder',
}

export type TDisablePlaceholder = ITypedReduxAction<EPlaceholderDisabledActionType.DisablePlaceholder, void>;

export type TPlaceholderDisabledActions = TDisablePlaceholder;
